exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ssg-form .change-password-action-bar {\n  background-color: inherit;\n  max-width: 416px;\n  text-align: right; }\n  .ssg-form .change-password-action-bar .ssg-forms-btn {\n    margin-left: 10px; }\n\n.ssg-form .full-width {\n  width: 100%; }\n\n@media (max-width: 768px) {\n  .ssg-form .change-password-action-bar {\n    max-width: unset; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/acct/password/change-password.scss
// module id = 1340
// module chunks = 0